/** Formato de Nº de cotización con ceros a la izquierda (mín. 3 dígitos). */
export const formatNumeroCotizacion = (v) => {
  if (v == null || v === '') return '';
  const s = String(v).trim();
  if (!/^\d+$/.test(s)) return s;
  const n = Number(s);
  if (!Number.isInteger(n) || n < 1) return s;
  return s.length >= 3 ? s : s.padStart(3, '0');
};

export const isNumeroCotizacionValido = (v) => {
  const s = String(v ?? '').trim();
  if (!/^\d+$/.test(s)) return false;
  const n = Number(s);
  return Number.isInteger(n) && n >= 1;
};
